import * as React from "react";
import IconButton from "@material-ui/core/IconButton";
import EditIcon from "@material-ui/icons/Edit";
import Tooltip from "@material-ui/core/Tooltip";
import { MUIDataTableMeta } from "mui-datatables";
import * as DatiFide from "../../../DatiFide";
import { Trad } from "../../../components";

export const GetBondsAssessmentListColumns = (ID_Anag: string, ID_FideAffidamento: string) => [
    {
        name: "ID_FideValutazione",
        label: "ID",
        options: {
            filter: false
        }
    },
    {
        name: "ImportoAffidamento",
        label: Trad.Trad("Importo affidamento"),
        options: {
            filter: false,
            customBodyRender: (val: string) => Trad.TradParam("{1-I}", [val]),
            setCellProps: () => ({
                align: "right"
            })
        }
    },
    {
        name: "TipoValutazioneEsito",
        label: "Esito",
        options: {
            filter: false
        }
    },
    {
        name: "Data",
        label: Trad.Trad("Data"),
        options: {
            filter: false,
            customBodyRender: (val: Date) => Trad.Trad(val)
        }
    },
    {
        name: "Utente",
        label: "Utente",
        options: {
            filter: false
        }
    },

    {
        name: "Edit",
        label: Trad.Trad("Modifica"),
        options: {
            filter: false,
            sort: false,
            setCellHeaderProps: () => ({
                align: "center"
            }),
            setCellProps: () => ({
                align: "center"
            }),
            customBodyRender: (val: string, tableMeta: MUIDataTableMeta) => {
                const rowData = { ...new DatiFide.CDatiFideValutazione(), ...tableMeta.tableData[tableMeta.rowIndex] };

                return (
                    <a href={`/anagrafica/${ID_Anag}/FideAffidamento/${ID_FideAffidamento}/FideValutazione/${rowData.ID_FideValutazione}`}>
                        <Tooltip title={Trad.Trad("Modifica")}>
                            <IconButton aria-label="edit" size="small">
                                <EditIcon />
                            </IconButton>
                        </Tooltip>
                    </a>
                );
            }
        }
    }
];



// WEBPACK FOOTER //
// ./src/inar2/components/BondsAssessmentList/BondsAssessmentListColumns.tsx